import { RenderStateStruct, WordArtRenderProps } from '../../type/common.interface';
import { draw } from '../draw/draw';
import { schedule } from '../schedule/schedule';
import { renderBg } from './render-bg';
import { renderChar } from './render-char';
import { renderLt } from './render-lt';
import { renderUl } from './render-ul';

export function renderCore({
    key,
    renderQuality,
    curScreenWidth,
    curScreenHeight,
    prstTxWarp,
    rectTextList,
    bgList,
}: WordArtRenderProps) {
    // 渲染状态
    const renderStateStruct: RenderStateStruct = {
        key,
        prstTxWarp,
        contentArea: { width: 0, height: 0, offset: { x: 0, y: 0 } },
        drawRatio: 1,
        scheduleRatio: 5,
        charStructList: [],
        charStructListLite: [],
        bgStructList: [],
        ulStructList: [],
        ltStructList: [],
    };

    // scheduleRatio
    const fontSizeList = rectTextList.map(({ fontSize }) => fontSize);
    const maxFontSize = Math.max(...fontSizeList);
    const fontSizeRatio = Math.ceil(300 / maxFontSize * renderQuality);
    renderStateStruct.scheduleRatio = Math.max(fontSizeRatio, 1) ;

    renderChar({ renderStateStruct, rectTextList });
    renderUl({ renderStateStruct, rectTextList });
    renderLt({ renderStateStruct, rectTextList });
    renderBg({ renderStateStruct, bgList });

    // 调度
    schedule(renderStateStruct);

    // drawRatio 类似缩略图
    renderStateStruct.drawRatio = Math.min(
        (curScreenWidth * curScreenHeight)
            / (renderStateStruct.contentArea.width * renderStateStruct.contentArea.height),
        1,
    );

    // 绘制
    const { imageData, width, height } = draw(renderStateStruct);

    return {
        key: renderStateStruct.key,
        imageData,
        width,
        height,
        contentArea: renderStateStruct.contentArea,
        charStructListLite: renderStateStruct.charStructListLite,
    };
}
